"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PickersDay_1 = __importDefault(require("@mui/lab/PickersDay"));
var styles_1 = require("@mui/material/styles");
var PickersDay = (0, styles_1.styled)(PickersDay_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        '&.Mui-selected': {
            color: theme.palette.common.white,
        },
        '&.MuiButtonBase-root:not(.Mui-selected)': {
            borderColor: theme.palette.secondary.main,
        },
        ':hover': {
            backgroundColor: theme.palette.secondary.light,
        },
    });
});
exports.default = PickersDay;
